import { render } from "./AddEditSapgCustom.vue?vue&type=template&id=203c881a"
import script from "./AddEditSapgCustom.vue?vue&type=script&lang=js"
export * from "./AddEditSapgCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__